
<component v-if="isCustomIcon" :is="customIcons[name]" class="icon custom" />
<i v-else class="icon material-icons">{{ name }}</i>
